import React, { useEffect, useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, FormControlLabel, Switch, useMediaQuery, useTheme
} from "@material-ui/core";

import { observer } from "mobx-react";
import {
    changeCheckboxEventHandlerDecorator,
    changeEventHandlerDecorator, toLocalizedString,

} from "../../../../../common/libs";
import {
    MenuItemModifier,
    MenuItemModifierData,
} from "../../../../../services/menu/models";
import { uploadFile } from "../../../../../services/files";


import {
    CircularProgress,
    FlexRowStart,
    FormControl, Space,
    TextField,
    Typography
} from "../../../../../common/components/libs";
import styles from "../../menuEditor/style.module.css";
import Dropzone from "react-dropzone";
import { Plus as AddIcon } from "react-feather";
import { useStores } from "../../../../../hooks";
import { generateClientSyncId } from "../../../../../apiCommandsExecutor";
import ImageCropperForm, { ImageAspectRatio } from "../../../../../common/components/ImageCropperForm";
import {Trans, useTranslation} from "react-i18next";
import LocalizedInput from "../../../../../common/components/translation/LocalizedInput";
import { LocalizedString } from "../../../../../services/general/models";


interface Props {
    current?: MenuItemModifier,
    open: boolean,
    handleDone: () => void,
    updateModifier: (modifier: MenuItemModifier) => void;
    pushNewModifier: (modifier: MenuItemModifier) => void;
}

const EditModifierForm = ({ current, open, updateModifier, pushNewModifier, handleDone }: Props) => {
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));
    const {menuStore} = useStores();
    const {t} = useTranslation(["general", "menu"]);
    const [name, setName] = useState("");

    const [sellPrice, setSellPrice] = useState<number>(0);
    const [photosUrls, setPhotosUrls] = useState<string[]>([]);
    const [localizedName, setLocalizedName] = useState<LocalizedString>()

    const [sellPriceToShow, setSellPriceToShow] = useState("");
    const [isInStopList, setIsInStopList] = useState(false);
    const [iikoId, setIikoId] = useState<string | null>(null);


    const [isUploadInProgress, setIsUploadInProgress] = useState(false);
    const [isImageCropperVisible, setIsImageCropperVisible] = useState(false);
    const [currentFile, setCurrentFile] = useState<File | undefined>();
    const { constantsStore, generalStore} = useStores();

    const currencyFormatter = constantsStore.getCurrencyFormatter(generalStore.currency.id);

    useEffect(() => {
        menuStore.modifier = current;
        if (current) {
            const data = current.data;
            setPhotosUrls(data.photosUrls);
            setLocalizedName(current.data.name)
            setIsInStopList(current.data.isInStopList)
            setSellPrice(data.sellPrice.price);
            setSellPriceToShow(currencyFormatter.toShow(data.sellPrice.price, true));
            setIikoId(current.externalId)
        } else {
            setLocalizedName(toLocalizedString(''))
            setName("");
            setPhotosUrls([]);
            setSellPrice(0);
            setSellPriceToShow("");
            setIsInStopList(false);
            setIikoId(null)
        }

        setIsImageCropperVisible(false);
        setCurrentFile(undefined);
        setIsImageCropperVisible(false);
    }, [current, open]);

    useEffect(() => {
        setLocalizedName(toLocalizedString(name))
    }, [name])
    useEffect(() => {
        setSellPriceToShow(currencyFormatter.toShow(sellPrice, true));
    },[]);

    const handleSubmit = async () => {
        const data: MenuItemModifierData = {
            name: localizedName,
            inputProductAmountNetto: null,
            productId: null,
            sellPrice: {
                currencyId: "RUB",
                price: sellPrice
            },
            photosUrls,
            isInStopList,
            outputProductAmountNetto: null,
            manufactureId: null
        };

        if (current) {
            updateModifier({
                id: current.id,
                externalId: iikoId,
                data:{...data, name: localizedName, manufactureId: current.data.manufactureId }});
        } else {
            pushNewModifier({
                id: generateClientSyncId(),
                data: {
                    ...data,
                    manufactureId: null
                },
                externalId: iikoId
            })
        }
        handleDone();
    };


    const uploadImage = async (file: File) => {
        setIsUploadInProgress(true);
        try {
            setPhotosUrls([]);
            const res = await uploadFile(file);
            const { downloadUrl } = res;
            setPhotosUrls([downloadUrl]);

        } catch (e) {
            console.log(e);
        } finally {
            setIsUploadInProgress(false);
        }
        return;
    };

    const onDrop = async (files: File[]) => {
        setCurrentFile(files[0]);
        setIsImageCropperVisible(true);
    };


    const setSellPriceWrapper = (value: string) => {
        setSellPrice(currencyFormatter.toSend(currencyFormatter.toFloat(value)));
        setSellPriceToShow(currencyFormatter.toStringFloat(value));
    };


    let imageBlockContent = [];

    if (!isUploadInProgress && photosUrls.length === 0) {
        imageBlockContent.push(
            <Dropzone onDrop={onDrop}  key='photoDropzone'>
                {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps({ className: styles.dropzone })}
                         style={{ minHeight: "150px", minWidth: "150px", borderRadius: 5 }}>
                        <input {...getInputProps()} />
                        <AddIcon size={30}/>
                        <span>{t("general:load")}</span>
                    </div>
                )}
            </Dropzone>
        )
    } else if (isUploadInProgress) {
        imageBlockContent.push(
            <div
                key='photoLoading'
                style={{
                    minHeight: "150px",
                    minWidth: "150px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <CircularProgress
                    m={2}
                    color="secondary"
                />
            </div>
        )
    }
    if (photosUrls.length > 0) {
        imageBlockContent.push(
            <div key='photoView'>
                <img src={photosUrls[0]}
                     alt=""
                     key={photosUrls[0]}
                     style={{
                         maxWidth: 150,
                         maxHeight: 150,
                         minWidth: 150,
                         minHeight: 150,
                         borderRadius: 10
                     }}
                />
            </div>,
            <Dropzone onDrop={onDrop} key='photoDropzone'>
                {({ getRootProps, getInputProps, open }) => (
                    <div {...getRootProps()}
                         style={{ textAlign: 'center' }}>
                        <input {...getInputProps()}  />
                        <Button color={"primary"}>{t("general:replace")}</Button>
                    </div>
                )}
            </Dropzone>
        );
    }


        return (
            <>
                <Dialog
                    open={open}
                    onClose={handleDone}
                    aria-labelledby="form-dialog-title"
                    fullWidth={true}
                    maxWidth={"sm"}
                    fullScreen={!isSm}
                >
                    <DialogTitle id="form-dialog-title">
                        {t("menu:modifiersSet.modifierDetails")}
                    </DialogTitle>
                    <DialogContent>
                        <form autoComplete="off">

                            <div style={{display: "flex", alignContent: "space-around"}}>
                                <div style={{marginRight: 20}}>
                                    {imageBlockContent}
                                </div>
                                <div style={{flexGrow: 1}}>
                                    {
                                        (current) &&
                                        <LocalizedInput
                                            label = {t("general:name")}
                                            value={current.data.name}
                                            setNewValue ={setLocalizedName}
                                        />
                                    }
                                    {
                                        !current &&
                                        <FormControl fullWidth mt={0}>
                                            <TextField
                                                onChange={changeEventHandlerDecorator(setName)}
                                                label={t("general:name")}
                                                variant="outlined"
                                                value={name}
                                            />
                                        </FormControl>
                                    }

                                    <FormControl fullWidth mt={4} variant="outlined" mr={3}>
                                        <TextField
                                            onChange={changeEventHandlerDecorator(setSellPriceWrapper)}
                                            label={t("menu:modifiersSet.priceCurrency")}
                                            variant="outlined"
                                            value={sellPriceToShow}
                                        />
                                    </FormControl>
                                </div>
                            </div>
                            <Space size={10}/>
                            <div>
                                <Typography variant={"h6"}>
                                    {t("menu:modifiersSet.sale")}
                                </Typography>
                                <FormControl>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={isInStopList}
                                                onChange={changeCheckboxEventHandlerDecorator(setIsInStopList)}
                                                value={!isInStopList}
                                            />
                                        }
                                        label={t("menu:modifiersSet.inStopList")}
                                    />
                                </FormControl>
                            </div>
                            <Space size={10}/>
                            <div>
                                <Typography variant={"h6"}>
                                    {t("menu:modifiersSet.integrations")}
                                </Typography>
                                <FormControl fullWidth mt={4} variant="outlined" mr={3}>
                                    <TextField
                                        onChange={changeEventHandlerDecorator(setIikoId)}
                                        label={t("menu:modifiersSet.externalId")}
                                        variant="outlined"
                                        value={iikoId}
                                    />
                                </FormControl>
                            </div>
                        </form>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleDone} color="primary">
                            {t("general:cancel")}
                        </Button>
                        <Button
                            color="primary"
                            variant='contained'
                            onClick={handleSubmit}
                        >
                            {t("general:continue")}
                        </Button>
                    </DialogActions>
                </Dialog>
                <ImageCropperForm
                    open={isImageCropperVisible}
                    close={() => {
                        setIsImageCropperVisible(false)
                    }}
                    image={currentFile}
                    uploadImage={uploadImage}
                    aspectRation={ImageAspectRatio.rectangle_3_2}
                />
            </>
        );

};

export default observer(EditModifierForm);
